import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class Notification extends Base {
  /**
   * @description List location API function
   * @returns {Promise<Response>}
   */
  list() {
    const url = this._getFullURL(`/notification`);
    return this._secureFetch(url);
  }
  listNotifThreshold() {
    const url = this._getFullURL(`/notification/threshold`);
    return this._secureFetch(url);
  }

  listNew() {
    const url = this._getFullURL(`/notification/new`);
    return this._secureFetch(url);
  }
}
